import { setGAEvent, setInview, authModal, decrypt } from '@/js/components/common'
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import Modal from '@/js/components/modal'

const main = () => {
    if (!document.querySelector('#page-chefevent')) return false;

    setInview(600)
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    const modal = new Modal

    // 詳細のモーダル表示
    $('article.detail').prev('a.button').on('click', e => {
        let html = $(e.currentTarget).next('.detail').get(0).outerHTML
        modal.setHtml(html)
        modal.show()
        setGAEvent(modal.settings.createDom)
        return false
    })

    // KVスライダー
    const swiper = new Swiper(".key-visual", {
        modules: [Autoplay, Pagination],
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 4000,
        autoplay: {
            delay: 3000,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
    })

    $('.button.resv-online').on('click', async (e) => {
        e.preventDefault()
        const link_url = $(e.currentTarget).attr('data-url')
        if(link_url){
            window.open(link_url, '_blank')
            return false
        }
        const stage = $(e.currentTarget).attr('data-stage')
        const encrypt = $(e.currentTarget).attr('data-encrypt')
        let resp = await authModal(stage, { token, encrypt })
            .catch((e) => {
                throw e;
            })
        if (resp.success) {
            const decrypted = decrypt(encrypt, resp.password)
            const { url } = JSON.parse(decrypted)
            window.open(url, '_blank')
        }
    });
}
export default main;